import { Base } from "./title.base";

export const Title = Object.assign(Base, {});
